import { Direction } from '../constants';

export interface Rule {
  next?: (params?: unknown) => void;
  prev?: (params?: unknown) => void;
  disableNext?: boolean;
  isLoading: boolean;
}

export enum FlowKind {
  INSTANT = 'instant',
  LAB = 'lab',
  FU_RESCHEDULE = 'fu-reschedule',
  RESCHEDULE = 'reschedule',
  OTHER_RESCHEDULE = 'other-reschedule',
  UPDATE = 'update',
  FOLLOWUP = 'followup',
  OTHER = 'other',
  SPECIFIC_LOCATION = 'specificLocation',
  INVALID_IP = 'invalidIp',
  ASSESSMENT_REPORT = 'assessmentReport',
  DEFAULT = 'default',
  DIANOSIS_EXPERIMENT = 'diagnosisExperiment',
}

export const FLOW_STEP_CONFIG = {
  [FlowKind.INSTANT]: [Direction.SELECT_MEDIUM, Direction.SELECT_LANGUAGE, Direction.QUESTIONNAIRE, Direction.CHECKOUT],
  [FlowKind.LAB]: [Direction.PERSONAL_DETAILS, Direction.SELECT_ADDRESS, Direction.SELECT_LAB_SLOT],
  [FlowKind.FU_RESCHEDULE]: [
    Direction.SELECT_RESCHEDULE_REASON,
    Direction.SELECT_MEDIUM,
    Direction.SELECT_LANGUAGE,
    Direction.SELECT_SLOT,
    Direction.CHECKOUT,
  ],
  [FlowKind.RESCHEDULE]: [
    Direction.SELECT_RESCHEDULE_REASON,
    Direction.SELECT_MEDIUM,
    Direction.SELECT_CLINIC,
    Direction.SELECT_LANGUAGE,
    Direction.SELECT_SLOT,
    Direction.CHECKOUT,
  ],
  [FlowKind.UPDATE]: [
    Direction.SELECT_MEDIUM,
    Direction.SELECT_CLINIC,
    Direction.SELECT_LANGUAGE,
    Direction.SELECT_SLOT,
    Direction.CHECKOUT,
  ],
  [FlowKind.FOLLOWUP]: [
    Direction.SELECT_MEDIUM,
    Direction.SELECT_CLINIC,
    Direction.SELECT_LANGUAGE,
    Direction.SELECT_SLOT,
    Direction.CHECKOUT,
  ],
  [FlowKind.OTHER_RESCHEDULE]: [Direction.SELECT_LANGUAGE, Direction.SELECT_SLOT, Direction.CHECKOUT],
  [FlowKind.OTHER]: [Direction.SELECT_LANGUAGE, Direction.SELECT_SLOT, Direction.CHECKOUT],
  [FlowKind.SPECIFIC_LOCATION]: [
    Direction.SELECT_MEDIUM,
    Direction.SELECT_CLINIC,
    Direction.SELECT_LANGUAGE,
    Direction.SELECT_SLOT,
    Direction.CHECKOUT,
  ],
  [FlowKind.DIANOSIS_EXPERIMENT]: [
    Direction.SELECT_DIAGNOSIS,
    Direction.SELECT_MEDIUM,
    Direction.SELECT_CLINIC,
    Direction.SELECT_LANGUAGE,
    Direction.SELECT_SLOT,
    Direction.CHECKOUT,
  ],
  [FlowKind.INVALID_IP]: [Direction.SELECT_LANGUAGE, Direction.SELECT_SLOT, Direction.CHECKOUT],
  [FlowKind.ASSESSMENT_REPORT]: [Direction.CHECKOUT],
  [FlowKind.DEFAULT]: [
    Direction.SELECT_MEDIUM,
    Direction.SELECT_CLINIC,
    Direction.SELECT_LANGUAGE,
    Direction.SELECT_SLOT,
    Direction.CHECKOUT,
  ],
};
